module.exports = __webpack_public_path__ + "a59df348d6ed93cf0b5c49d1fe080c47.svg";